import { Component } from '@angular/core';
import { BaseModalComponent } from '../../base-modal.component';
import { ModalService } from '../../../../services/modal/modal.service';

@Component({
  moduleId: module.id,
  selector: 'replacement-alir-1035',
  templateUrl: './replacementALIR1035.component.html',
})
export class ReplacementALIR1035Component extends BaseModalComponent {
  constructor(protected modalService: ModalService) {
    super(modalService);
  }

  cancel() {
    this.modalService.deactivate();
  }

  confirm() {
    this.modalService.deactivate();
  }
}
